import { createAction } from 'redux-actions';
export var NAMES = {
    UPDATE_VIDEO_LIVE_STATUS: 'CLIENT.VIDEOS.UPDATE_LIVE_STATUS',
};
export var updateLiveStatus = createAction(NAMES.UPDATE_VIDEO_LIVE_STATUS);
